import type { ValueFormatterParams } from 'ag-grid-community';
import type { FixingIndex } from '../../../types';
import { baseColumn } from './baseColumn';
import type { ColDefFactory, Column } from './types';

export interface FixingIndexColumnParams {
  valueType?: keyof Pick<FixingIndex, 'Name' | 'IndexID'>;
}

/** Column that takes either a FixingIndex.Name or FixingIndex.IndexID and renders DisplayName when available. */
export const fixingIndex: ColDefFactory<Column<FixingIndexColumnParams>> = column => ({
  ...baseColumn(column),
  valueFormatter: ({ value, context }: ValueFormatterParams<unknown, any>) => {
    if (!value) {
      return '';
    }
    if (typeof value !== 'string') {
      return value;
    }
    const valueType = column.params?.valueType ?? 'Name';

    if (valueType === 'IndexID') {
      return context.current.fixingIndicesByID?.get(value)?.DisplayName || value;
    }

    return context.current.fixingIndicesByName?.get(value)?.DisplayName || value;
  },
});
